'use strict';

require("core-js/modules/es.array.reduce.js");

var _slicedToArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var ScrollLock = require('react-scrolllock');

var framerMotion = require('framer-motion');

var reactDom = require('react-dom');

var classNames = require('classnames');

var PopperJS = require('popper.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ScrollLock__default = /*#__PURE__*/_interopDefaultLegacy(ScrollLock);

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var PopperJS__default = /*#__PURE__*/_interopDefaultLegacy(PopperJS);

var useExitListener = function useExitListener(_ref) {
  var ref = _ref.ref,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open,
      onClickOutside = _ref.onClickOutside,
      onEscape = _ref.onEscape;
  React.useLayoutEffect(function () {
    var handleClick = function handleClick(event) {
      var el = ref.current;

      if (!(el === null || el === void 0 ? void 0 : el.contains(event.target)) && event.which !== 3) {
        onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside(event);
      }
    };

    var handleKey = function handleKey(event) {
      if (event.keyCode === 27) {
        onEscape === null || onEscape === void 0 ? void 0 : onEscape(event);
      }
    };

    if (open) {
      if (onClickOutside) {
        document.addEventListener('mousedown', handleClick);
        document.addEventListener('touchstart', handleClick);
      }

      if (handleKey) {
        document.addEventListener('keydown', handleKey);
      }
    }

    return function () {
      if (onClickOutside) {
        document.removeEventListener('mousedown', handleClick);
        document.removeEventListener('touchstart', handleClick);
      }

      if (handleKey) {
        document.removeEventListener('keydown', handleKey);
      }
    };
  }, [ref, onClickOutside, onEscape, open]);
};

var OverlayContext = React.createContext({
  close: function close() {
    return undefined;
  }
});
var id = 0;

var genId = function genId() {
  return ++id;
};
/**
 * Auto-generate a id.
 * Inspired by: https://github.com/reach/reach-ui/blob/master/packages/auto-id/src/index.ts
 */


var useId = function useId(idFromProps) {
  var _React$useState = React.useState(idFromProps || genId()),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      id = _React$useState2[0];

  return "ref-".concat(id);
};

var useUnmount = function useUnmount(fn) {
  var fnRef = React.useRef(fn);
  fnRef.current = fn;
  React.useLayoutEffect(function () {
    return function () {
      return fnRef.current();
    };
  }, []);
};

var Portal = React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$element = _ref2.element,
      element = _ref2$element === void 0 ? 'div' : _ref2$element,
      _ref2$onMount = _ref2.onMount,
      onMount = _ref2$onMount === void 0 ? function () {
    return undefined;
  } : _ref2$onMount,
      _ref2$onUnmount = _ref2.onUnmount,
      onUnmount = _ref2$onUnmount === void 0 ? function () {
    return undefined;
  } : _ref2$onUnmount;
  var elementRef = React.useRef(document.createElement(element));
  var mounted = React.useRef(false);
  React.useEffect(function () {
    if (className) {
      elementRef.current.setAttribute('class', className);
    }
  }, [className]);
  React.useLayoutEffect(function () {
    onMount === null || onMount === void 0 ? void 0 : onMount();
  }, []);
  useUnmount(function () {
    onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
    document.body.removeChild(elementRef.current);
  });

  if (!mounted.current) {
    mounted.current = true;
    document.body.appendChild(elementRef.current);
  }

  var portal = reactDom.createPortal(children, elementRef.current);
  React.useImperativeHandle(ref, function () {
    return elementRef.current;
  });
  return portal;
});
var portals = [];
var START_INDEX = 990;
var OverlayPortal = React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
      children = _ref3.children,
      _onMount = _ref3.onMount,
      _onUnmount = _ref3.onUnmount,
      _ref3$appendToBody = _ref3.appendToBody,
      appendToBody = _ref3$appendToBody === void 0 ? true : _ref3$appendToBody;
  var id = useId();

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      portalIndex = _React$useState4[0],
      setPortalIndex = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      overlayIndex = _React$useState6[0],
      setOverlayIndex = _React$useState6[1];

  var portalRef = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return portalRef.current;
  });
  return React__default['default'].createElement(Portal, {
    className: className,
    ref: portalRef,
    appendToBody: appendToBody,
    onMount: function onMount() {
      portals.push(id);
      var pidx = portals.indexOf(id);

      if (pidx === -1) {
        pidx = 0;
      }

      setPortalIndex(pidx);
      var overlayIdx = START_INDEX + pidx * 2 + 1;
      setOverlayIndex(overlayIdx);
      _onMount === null || _onMount === void 0 ? void 0 : _onMount({
        overlayIndex: overlayIdx,
        portalIndex: pidx,
        backdropIndex: overlayIdx
      });
    },
    onUnmount: function onUnmount() {
      _onUnmount === null || _onUnmount === void 0 ? void 0 : _onUnmount();
      portals.splice(portals.indexOf(id), 1);
      setPortalIndex(null);
      setOverlayIndex(null);
    }
  }, children({
    overlayIndex: overlayIndex,
    portalIndex: portalIndex,
    backdropIndex: overlayIndex
  }));
});

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Backdrop-module_backdrop__2tEGU {\n  position: fixed;\n  background: var(--color-layer-transparent);\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  opacity: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n";
var css = {
  "backdrop": "Backdrop-module_backdrop__2tEGU"
};
styleInject(css_248z);

var Backdrop = function Backdrop(_ref4) {
  var _ref4$portalIndex = _ref4.portalIndex,
      portalIndex = _ref4$portalIndex === void 0 ? 0 : _ref4$portalIndex,
      _ref4$zIndex = _ref4.zIndex,
      zIndex = _ref4$zIndex === void 0 ? 998 : _ref4$zIndex,
      className = _ref4.className,
      _ref4$onClick = _ref4.onClick,
      onClick = _ref4$onClick === void 0 ? function () {
    return undefined;
  } : _ref4$onClick;
  return React__default['default'].createElement(framerMotion.motion.div, {
    className: classNames__default['default'](css.backdrop, className),
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.8 - portalIndex / 10
    },
    exit: {
      opacity: 0
    },
    style: {
      zIndex: zIndex
    },
    onClick: onClick
  });
};

var GlobalOverlay = function GlobalOverlay(_ref5) {
  var open = _ref5.open,
      _ref5$hasBackdrop = _ref5.hasBackdrop,
      hasBackdrop = _ref5$hasBackdrop === void 0 ? true : _ref5$hasBackdrop,
      _ref5$closeOnEscape = _ref5.closeOnEscape,
      closeOnEscape = _ref5$closeOnEscape === void 0 ? true : _ref5$closeOnEscape,
      _ref5$closeOnBackdrop = _ref5.closeOnBackdropClick,
      closeOnBackdropClick = _ref5$closeOnBackdrop === void 0 ? true : _ref5$closeOnBackdrop,
      backdropClassName = _ref5.backdropClassName,
      children = _ref5.children,
      _ref5$onClose = _ref5.onClose,
      onClose = _ref5$onClose === void 0 ? function () {
    return undefined;
  } : _ref5$onClose;
  var overlayRef = React.useRef(null);
  var onBackdropClick = React.useCallback(function () {
    if (closeOnBackdropClick) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  }, [closeOnBackdropClick]);
  useExitListener({
    ref: overlayRef,
    open: open,
    onEscape: function onEscape() {
      return closeOnEscape && (onClose === null || onClose === void 0 ? void 0 : onClose());
    }
  });
  return React__default['default'].createElement(OverlayContext.Provider, {
    value: {
      close: function close() {
        return onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    }
  }, React__default['default'].createElement(framerMotion.AnimatePresence, null, open && React__default['default'].createElement(OverlayPortal, {
    ref: overlayRef
  }, function (_ref6) {
    var overlayIndex = _ref6.overlayIndex,
        portalIndex = _ref6.portalIndex;
    return React__default['default'].createElement(React.Fragment, null, hasBackdrop && React__default['default'].createElement(Backdrop, {
      zIndex: overlayIndex,
      portalIndex: portalIndex,
      onClick: onBackdropClick,
      className: backdropClassName
    }), children({
      overlayIndex: overlayIndex,
      portalIndex: portalIndex
    }), React__default['default'].createElement(ScrollLock__default['default'], null));
  })));
};

var OverlayTrigger = React.forwardRef(function (_ref7, ref) {
  var children = _ref7.children,
      className = _ref7.className,
      _ref7$elementType = _ref7.elementType,
      elementType = _ref7$elementType === void 0 ? 'span' : _ref7$elementType,
      _ref7$trigger = _ref7.trigger,
      trigger = _ref7$trigger === void 0 ? ['click'] : _ref7$trigger,
      _ref7$onOpen = _ref7.onOpen,
      onOpen = _ref7$onOpen === void 0 ? function () {
    return undefined;
  } : _ref7$onOpen,
      _ref7$onClose = _ref7.onClose,
      onClose = _ref7$onClose === void 0 ? function () {
    return undefined;
  } : _ref7$onClose;
  var hasTrigger = React.useCallback(function (type) {
    if (Array.isArray(trigger)) {
      return trigger.includes(type);
    } else {
      return type === trigger;
    }
  }, [trigger]);
  var onFocus = React.useCallback(function (event) {
    if (hasTrigger('focus')) {
      onOpen({
        type: 'focus',
        nativeEvent: event
      });
    }
  }, [onOpen, hasTrigger]);
  var onBlur = React.useCallback(function (event) {
    if (hasTrigger('focus')) {
      onClose({
        type: 'focus',
        nativeEvent: event
      });
    }
  }, [onClose, hasTrigger]);
  var onMouseEnter = React.useCallback(function (event) {
    if (hasTrigger('hover')) {
      onOpen({
        type: 'hover',
        nativeEvent: event
      });
    }
  }, [onOpen, hasTrigger]);
  var onMouseLeave = React.useCallback(function (event) {
    if (hasTrigger('hover')) {
      onClose({
        type: 'hover',
        nativeEvent: event
      });
    }
  }, [onClose, hasTrigger]);
  var onClick = React.useCallback(function (event) {
    if (hasTrigger('click')) {
      onOpen({
        type: 'click',
        nativeEvent: event
      });
    } // Kill the tooltip on click if its not a click listener


    if (!hasTrigger('click')) {
      onClose({
        type: 'hover',
        nativeEvent: event
      });
    }
  }, [onOpen, onClose, hasTrigger]);
  var onContextMenu = React.useCallback(function (event) {
    if (hasTrigger('contextmenu')) {
      event.preventDefault();
      onOpen({
        type: 'contextmenu',
        nativeEvent: event
      });
    }
  }, [onOpen]);
  var tabIndex = hasTrigger('focus') ? -1 : undefined;
  var Component = elementType;
  return React__default['default'].createElement(Component, {
    ref: ref,
    tabIndex: tabIndex,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onClick,
    onContextMenu: onContextMenu,
    className: className
  }, children);
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var usePosition = function usePosition(reference) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      followCursor = _ref8.followCursor,
      placement = _ref8.placement,
      modifiers = _ref8.modifiers;

  var elementRef = React.useRef(null);
  var popper = React.useRef(null);
  var mouse = React.useRef({
    pageX: 0,
    pageY: 0
  }); // Find the real reference pointer for updating

  var refPointer = reference.current;
  var popperRef = React.useMemo(function () {
    var refObj = reference;

    if (refObj.current !== undefined) {
      return refObj.current;
    }

    var refElement = reference;

    if (followCursor) {
      return {
        getBoundingClientRect: function getBoundingClientRect() {
          return {
            top: mouse.current.pageY,
            right: mouse.current.pageX,
            bottom: mouse.current.pageY,
            left: mouse.current.pageX,
            width: 0,
            height: 0
          };
        },
        clientWidth: 0,
        clientHeight: 0
      };
    } else if (refElement && !refElement.getBoundingClientRect) {
      var top = reference.top,
          left = reference.left,
          width = reference.width,
          height = reference.height;
      return {
        getBoundingClientRect: function getBoundingClientRect() {
          return {
            top: top,
            left: left,
            width: width,
            bottom: top - height,
            right: left - width,
            height: height
          };
        },
        clientWidth: width,
        clientHeight: height
      };
    }

    return refElement;
  }, [followCursor, reference, refPointer, mouse]);
  React.useLayoutEffect(function () {
    var rqf;

    var onMouseMove = function onMouseMove(_ref9) {
      var pageX = _ref9.pageX,
          pageY = _ref9.pageY;

      var _a;

      mouse.current = {
        pageX: pageX,
        pageY: pageY
      };
      (_a = popper.current) === null || _a === void 0 ? void 0 : _a.scheduleUpdate();
    };

    var onWindowScroll = function onWindowScroll() {
      rqf = requestAnimationFrame(function () {
        var _a;

        (_a = popper.current) === null || _a === void 0 ? void 0 : _a.scheduleUpdate();
      });
    };

    if (elementRef.current && popperRef) {
      popper.current = new PopperJS__default['default'](popperRef, elementRef.current, {
        placement: placement || 'top',
        modifiers: modifiers || {},
        onCreate: function onCreate() {
          window.addEventListener('scroll', onWindowScroll);

          if (followCursor) {
            window.addEventListener('mousemove', onMouseMove);
          }
        }
      });
    }

    return function () {
      var _a;

      if (!elementRef.current) {
        (_a = popper.current) === null || _a === void 0 ? void 0 : _a.destroy();
        cancelAnimationFrame(rqf);
        window.removeEventListener('scroll', onWindowScroll);

        if (followCursor) {
          window.removeEventListener('mousemove', onMouseMove);
        }
      }
    };
  }, [elementRef.current]);
  React.useLayoutEffect(function () {
    if (popper.current) {
      popper.current.reference = popperRef;
      popper.current.scheduleUpdate();
    }
  }, [popperRef]);
  return [elementRef, popper];
};

var ConnectedOverlayContent = React.forwardRef(function (_ref10, ref) {
  var triggerRef = _ref10.triggerRef,
      children = _ref10.children,
      portalClassName = _ref10.portalClassName,
      _ref10$closeOnBodyCli = _ref10.closeOnBodyClick,
      closeOnBodyClick = _ref10$closeOnBodyCli === void 0 ? true : _ref10$closeOnBodyCli,
      _ref10$closeOnEscape = _ref10.closeOnEscape,
      closeOnEscape = _ref10$closeOnEscape === void 0 ? true : _ref10$closeOnEscape,
      elementType = _ref10.elementType,
      _ref10$appendToBody = _ref10.appendToBody,
      appendToBody = _ref10$appendToBody === void 0 ? true : _ref10$appendToBody,
      followCursor = _ref10.followCursor,
      modifiers = _ref10.modifiers,
      _ref10$placement = _ref10.placement,
      placement = _ref10$placement === void 0 ? 'bottom' : _ref10$placement,
      onClose = _ref10.onClose;

  var _React$useState7 = React.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      overlayIndex = _React$useState8[0],
      setOverlayIndex = _React$useState8[1];

  var _usePosition = usePosition(triggerRef, {
    followCursor: followCursor,
    modifiers: modifiers,
    placement: placement
  }),
      _usePosition2 = _slicedToArray(_usePosition, 2),
      positionRef = _usePosition2[0],
      popperRef = _usePosition2[1];

  React.useImperativeHandle(ref, function () {
    return {
      updatePosition: function updatePosition() {
        var _a;

        (_a = popperRef === null || popperRef === void 0 ? void 0 : popperRef.current) === null || _a === void 0 ? void 0 : _a.scheduleUpdate();
      }
    };
  });
  useExitListener({
    open: true,
    ref: positionRef,
    onClickOutside: function onClickOutside(event) {
      if (closeOnBodyClick) {
        var _ref11 = null;

        if (triggerRef.current) {
          _ref11 = triggerRef.current;
        } else if (triggerRef.contains !== undefined) {
          _ref11 = triggerRef;
        }

        if (_ref11 && !_ref11.contains(event.target)) {
          onClose === null || onClose === void 0 ? void 0 : onClose(event);
        }
      }
    },
    onEscape: function onEscape() {
      return closeOnEscape && (onClose === null || onClose === void 0 ? void 0 : onClose());
    }
  });
  React.useEffect(function () {
    if (positionRef && overlayIndex) {
      positionRef.current.style.zIndex = overlayIndex;
    }
  }, [positionRef.current, overlayIndex]);
  return React__default['default'].createElement(OverlayPortal, {
    ref: positionRef,
    className: portalClassName,
    elementType: elementType,
    appendToBody: appendToBody,
    onMount: function onMount(event) {
      return setOverlayIndex(event.overlayIndex);
    },
    onUnmount: function onUnmount() {
      return setOverlayIndex(null);
    }
  }, children);
});
var ConnectedOverlay = React.forwardRef(function (_a, ref) {
  var reference = _a.reference,
      children = _a.children,
      open = _a.open,
      content = _a.content,
      triggerElement = _a.triggerElement,
      triggerClassName = _a.triggerClassName,
      _a$trigger = _a.trigger,
      trigger = _a$trigger === void 0 ? 'click' : _a$trigger,
      onOpen = _a.onOpen,
      onClose = _a.onClose,
      rest = __rest(_a, ["reference", "children", "open", "content", "triggerElement", "triggerClassName", "trigger", "onOpen", "onClose"]);

  var mounted = React.useRef(false);
  var overlayTriggerRef = React.useRef(null);
  var contentRef = React.useRef(null);
  var triggerRef = reference || overlayTriggerRef;
  React.useImperativeHandle(ref, function () {
    return {
      updatePosition: function updatePosition() {
        var _a;

        (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
      }
    };
  });
  React.useEffect(function () {
    if (mounted.current) {
      if (!open) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      } else {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
      }
    } else {
      mounted.current = true;
    }
  }, [open]);
  return React__default['default'].createElement(OverlayContext.Provider, {
    value: {
      close: function close() {
        return onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    }
  }, children && React__default['default'].createElement(React.Fragment, null, trigger ? React__default['default'].createElement(OverlayTrigger, {
    elementType: triggerElement,
    ref: overlayTriggerRef,
    className: triggerClassName,
    trigger: trigger,
    onOpen: onOpen,
    onClose: onClose
  }, children) : children), React__default['default'].createElement(framerMotion.AnimatePresence, null, open && React__default['default'].createElement(ConnectedOverlayContent, Object.assign({}, rest, {
    ref: contentRef,
    triggerRef: triggerRef,
    onClose: onClose
  }), content)));
});

var useOverlay = function useOverlay() {
  var context = React.useContext(OverlayContext);

  if (context === undefined) {
    throw new Error('`useOverlay` hook can only be used inside a overlay component.');
  }

  return context;
};
/**
 * CloneElement is a wrapper component for createElement function.
 * This allows you to describe your cloning element declaratively
 * which is a more natural API for React.
 */


function CloneElement(_a) {
  var children = _a.children,
      element = _a.element,
      childRef = _a.childRef,
      rest = __rest(_a, ["children", "element", "childRef"]);

  var getProjectedProps = React.useMemo(function () {
    return function (props) {
      var childProps = element.props;
      return Object.keys(props).reduce(function (acc, key) {
        var prop = props[key];
        var childProp = childProps[key];

        if (typeof prop === 'function' && typeof childProp === 'function') {
          acc[key] = function () {
            prop.apply(void 0, arguments);
            childProp.apply(void 0, arguments);
          };
        } else if (key === 'className') {
          acc[key] = classNames__default['default'](prop, childProp);
        } else {
          acc[key] = prop;
        }

        return acc;
      }, {});
    };
  }, [rest]);

  if (element === null) {
    return children;
  } // Tricky logic around functional vs class components


  var ref = childRef ? function (node) {
    if (typeof childRef === 'function') {
      childRef(node);
    } else if (ref) {
      childRef.current = node;
    }
  } : undefined;
  var newProps = getProjectedProps(rest);
  return React.cloneElement(element, Object.assign(Object.assign(Object.assign({}, element.props), newProps), {
    children: children,
    ref: ref
  }));
}

exports.Backdrop = Backdrop;
exports.CloneElement = CloneElement;
exports.ConnectedOverlay = ConnectedOverlay;
exports.GlobalOverlay = GlobalOverlay;
exports.OverlayContext = OverlayContext;
exports.OverlayPortal = OverlayPortal;
exports.OverlayTrigger = OverlayTrigger;
exports.Portal = Portal;
exports.useExitListener = useExitListener;
exports.useId = useId;
exports.useOverlay = useOverlay;
exports.usePosition = usePosition;